/**
 * The English indefinite article a word needs: `"an"` before a vowel-leading
 * word, `"a"` otherwise.
 *
 * Deliberately spelled by the label's own first LETTER rather than by sound,
 * and deliberately case-insensitive: the two call-site families differ in
 * case - entity-type labels are title-case ("Individual", "Trust") while
 * ledger account types are uppercase enum names ("ASSET", "LIABILITY") - and
 * a case-insensitive test returns the same answer for both.
 *
 * A word beginning with a vowel LETTER but a consonant sound ("a university",
 * "a one-off") gets the wrong article here. No current caller produces one;
 * a caller that can should pass its own article rather than widening this
 * rule into a pronunciation dictionary.
 *
 * Examples:
 *   indefiniteArticle('Individual') // 'an'
 *   indefiniteArticle('Trust')      // 'a'
 *   indefiniteArticle('ASSET')      // 'an'
 *   indefiniteArticle('LIABILITY')  // 'a'
 */
export function indefiniteArticle(word) {
    return /^[aeiou]/i.test(word) ? 'an' : 'a';
}
